import { State } from 'reducers';

export const isLoading = (state: State) => state.app.loading;

export const getInitError = (state: State) => state.app.initError;

export const getRequestedCameraAndTime = (state: State) => state.app.cameraAndTime;

export const getRequestedView = (state: State) => state.app.view;



// WEBPACK FOOTER //
// ./src/selectors/appSelectors.ts